import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const UserMessagesService = {
    getUserOptions: async () => axios.get(`${API_URL}/user-messages/get/userOptions`).then(({ data }) => data.map(item => ({...item, roles: JSON.parse(item.roles)})) ).catch((err) => { throw err }),

    getByCreatedUser: async () => axios.get(`${API_KEEPER}/user-messages/getByCreatedUser`).then(({data}) => data).catch((err) => { throw err }),

    updateStatus: async (form) => axios.post(`${API_KEEPER}/user-messages/updateStatus`, form).catch((err) => { throw err }),

    toggleFavorite: async (form) => axios.post(`${API_KEEPER}/user-messages/toggleFavorite`, form).catch((err) => { throw err }),

    getUsersReceiverByMessageId: async (id) => axios.get(`${API_KEEPER}/user-message/getUsersReceiverByMessageId/${id}`).then(({data}) => data).catch((err) => { throw err }),

    save: async (form) => axios.post(`${API_KEEPER}/user-messages`, form).catch((err) => { throw err }),
};

export default UserMessagesService;